import React from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import MarketingLayout from "../../components/marketing/MarketingLayout";
import Seo from "../../components/Seo";
import { SOLUTIONS } from "../../data/site";

export function Solutions() {
  return (
    <MarketingLayout>
      <Seo title="Solutions — AllToMAIDIt Solutions" description="Industry solutions for small business, real estate, churches & nonprofits, and education." />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-20">
        <p className="eyebrow text-alto-red mb-3">Solutions</p>
        <h1 className="font-display text-4xl sm:text-5xl font-extrabold mb-4">Solutions shaped around your world.</h1>
        <p className="text-neutral-400 max-w-2xl mb-10 text-sm sm:text-base">Same powerful platform, configured for your industry's language, pipeline and workflow.</p>

        {/* Flagship solution */}
        <Link to="/solutions/lead-to-client" data-testid="solution-flagship" className="block mb-10 rounded-2xl p-8 bg-gradient-to-br from-alto-red/20 to-black border border-alto-red/40 group">
          <p className="eyebrow text-alto-red mb-3">Flagship Solution</p>
          <h2 className="font-display text-2xl sm:text-3xl font-extrabold group-hover:text-alto-red transition-colors">AllToMAIDIt Lead-to-Client System</h2>
          <p className="text-neutral-300 mt-3 max-w-2xl text-sm">The complete customer-acquisition system: capture, CRM, follow-up, attribution and reporting — from first click to closed customer.</p>
          <span className="inline-flex items-center gap-2 text-alto-red text-sm font-semibold mt-5">Explore the system <ArrowRight size={15} /></span>
        </Link>

        <h2 className="font-display text-xl font-bold mb-5 text-neutral-300">Industry solutions</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {SOLUTIONS.map((s) => (
            <Link key={s.slug} to={`/solutions/${s.slug}`} data-testid={`solution-card-${s.slug}`} className="card-hairline rounded-xl p-7 bg-alto-charcoal group">
              <s.icon className="text-alto-red mb-5" size={28} />
              <h2 className="font-display text-xl font-bold group-hover:text-alto-red transition-colors">{s.name}</h2>
              <p className="text-sm text-neutral-400 mt-2">{s.tagline}</p>
              <span className="inline-flex items-center gap-2 text-alto-red text-sm font-semibold mt-5">Explore <ArrowRight size={15} /></span>
            </Link>
          ))}
        </div>
      </div>
    </MarketingLayout>
  );
}

export function SolutionDetail() {
  const { slug } = useParams();
  const s = SOLUTIONS.find((x) => x.slug === slug);
  if (!s) return <MarketingLayout><div className="max-w-3xl mx-auto px-6 py-28 text-center"><h1 className="font-display text-3xl font-bold">Solution not found</h1><Link to="/solutions" className="text-alto-red mt-4 inline-block">Back to Solutions</Link></div></MarketingLayout>;
  return (
    <MarketingLayout>
      <Seo title={`${s.name} — AllToMAIDIt Solutions`} description={s.desc} />
      <div className="marketing-grid-bg border-b border-white/10">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-12 py-20">
          <Link to="/solutions" className="text-sm text-neutral-400 hover:text-white">← All Solutions</Link>
          <s.icon className="text-alto-red my-6" size={40} />
          <h1 className="font-display text-4xl sm:text-5xl font-extrabold">{s.name}</h1>
          <p className="text-neutral-300 mt-5 max-w-2xl text-sm sm:text-lg leading-relaxed">{s.desc}</p>
        </div>
      </div>
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-12 py-16">
        <h2 className="font-display text-2xl font-bold mb-8">Outcomes</h2>
        <div className="grid sm:grid-cols-2 gap-4">
          {s.outcomes.map((p) => (
            <div key={p} className="flex items-start gap-3 card-hairline rounded-lg p-5 bg-alto-charcoal"><Check className="text-alto-red shrink-0 mt-0.5" size={18} /><span className="text-sm text-neutral-200">{p}</span></div>
          ))}
        </div>
        <div className="mt-12 flex flex-col sm:flex-row gap-4">
          <Link to="/contact" className="btn-red font-bold px-7 py-4 rounded-md inline-flex items-center justify-center gap-2 text-sm">LET'S BUILD YOUR SOLUTION <ArrowRight size={18} /></Link>
          <Link to="/products/crm" className="font-bold px-7 py-4 rounded-md border border-white/20 hover:border-alto-red hover:text-alto-red transition-colors text-sm text-center">EXPLORE CRM</Link>
        </div>
      </div>
    </MarketingLayout>
  );
}
